import { render } from "./TrainerList.vue?vue&type=template&id=34ed6ae0&ts=true"
import script from "./TrainerList.vue?vue&type=script&lang=ts"
export * from "./TrainerList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__